const resource = `/api/people`

import Client from "@/repositories/Client/AxiosClient.js"

export default {
  list() {
    return Client.get(`${resource}`)
  },
  create(newAddress, personId) {
    return Client.post(`${resource}/${personId}/addresses`, newAddress)
  },
  show() {
    return Client.get(`${resource}`)
  },
  update(newAddress, personId) {
    return Client.put(`${resource}/${personId}/addresses`, newAddress)
  },
  delete(personId, addressId) {
    return Client.delete(`${resource}/${personId}/addresses/${addressId}`)
  },
}
